<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "FairstonePlans",
  data() {
    return {};
  },
};
</script>
